<template>
  <div>

    <Button
      :size="15"
      color="#33BDFF"
      colorText="#ffffff"
      tooltip="Editar Múltiples"
      icon="fas fa-edit"
      round
      :width="30"
      class="mt-2 mb-3 mr-2"
      @click.native="editarMultiple();"
      translate
    />

    <ui-modal
      ref="modal"
      title="Editar Múltiple Acuerdos Clientes Base"
      size="auto"
      class="modal-editar-multiple-acuerdo-cliente-base"
      @close="ActionSetZindexTablaModal(false)"
    >

      <div> 
        <data-table-acuerdos-clientes-base
          customHeaders
          :headers="headers"
          :data="dataAux"
          idtabla="listado_editar-cliente-base"
          :formulario="true"
          :acciones="[]"
          :load="load"
          
          :filtroCommodity="filtroCommodity"
          :filtroContenedores="filtroContenedores"
          :filtroAtmosferas="filtroAtmosferas"
          :filtroColdtreatment="filtroColdtreatmentAux"
        />
      </div>
      <!-- Footer -->
      <div class="d-flex justify-content-between mt-2">
        <button class="btn btn-default" @click="closeModal('modal')">
          Cerrar
        </button>
        <button class="btn btn-outline-warning" @click="filtrar()" id="buttonRefEditarAcuerdoLineas">
          Actualizar
        </button>
      </div>

    </ui-modal>

  </div>
</template>

<script>
// Common
import { mapActions, mapState } from "vuex";

import { 
  getAcuerdosClientesBaseByIds,
  getAcuerdosClientesBase, 
  editarAcuerdoBaseClientes, 
  getListasAcuerdosBase
} from "@/constants/lineas";

import DataTableAcuerdosClientesBase from "../../../../dataTables/tarifas/DataTableAcuerdosClientesBase";

import Button from "../../../../common/Button";

export default {
  
  props:["vaciarClienteBase","acuerdoClientesBaseArreglo","data","limpiarChecks","filtroColdtreatment"],

  data() {
    return {
      dataAux: [],
      load : true ,
      filtroCommodity: [],
      filtroContenedores: [],
      filtroAtmosferas: [],
      filtroColdtreatmentAux: [],
      headers:[
        { title: "N°", width: "5px" },
        { title: "Cliente", width: "20px" },
        { title: "Naviera", width: "20px" },
        { title: "Naviera Salida", width: "20px" },
        { title: "POL", width: "40px" },
        { title: "POD", width: "40px" },
        { title: "Desde", width: "150px" },
        { title: "Hasta", width: "150px" },
        { title: "Vigencia", width: "150px" },
        { title: "TT", width: "10px" },
        { title: "Pública (Venta)", width: "10px" },
        { title: "Neta (Costo)", width: "10px" },
        { title: "Margen", width: "10px" },
        { title: "Neta Cte.", width: "20px" },
        { title: "Descuento", width: "10px" },
        { title: "Unidad", width: "90px" },
        { title: "Commodity", width: "90px" },
        { title: "Atmósfera", width: "35px" },
        { title: "Trat. frío", width: "35px" },
        { title: "Dias Libres Origen", width: "10px" },
        { title: "Dias Plug Origen", width: "10px" },
        { title: "Dias Libres Destino", width: "10px" },
        { title: "Dias Plug Destino", width: "10px" },
        { title: "Genset", width: "2px" },
        { title: "Get Out", width: "2px" },
        { title: "Comentarios", width: "240px" },
        { title: "Tipo Contrato", width: "40px" },
        { title: "Contrato - Número", width: "70px" },
      ]
    };
  },
  methods: {
    ...mapActions(["ActionsSetShowModalAcuerdoLineasClienteBase"]),
    ...mapActions("lineas", ["actionSetDataListarTarifasAcuerdosClientesBase"]),
    ...mapActions(["ActionSetZindexTablaModal"]),
    
    estadoButton(text, estado = true) {
      let buttonRef = document.querySelector("#buttonRefEditarAcuerdoLineas");
      buttonRef.innerHTML = text;
      buttonRef.disabled = estado;
    },
    async filtrar(){
      
      let valid = true ;

      for ( const d of this.dataAux ) {

        if( d.cliente_id.id === undefined || d.cliente_id.id === "" )  {
          this.$vToastify.error( "Campo Cliente requerido", "¡Error!" );
          valid = false ;
          break ;
        }

        if( d.naviera.id === undefined || d.naviera.id === "" ){
          this.$vToastify.error( "Campo Naviera requerido", "¡Error!");
          valid = false ;
          break ;
        } 
        if( d.pod.id === undefined || d.pod.id === "" ){
          this.$vToastify.error( "Campo POD requerido", "¡Error!");
          valid = false ;
          break ;
        }
        if( d.pol.id === undefined || d.pol.id === "" ){
          this.$vToastify.error( "Campo POL requerido", "¡Error!");
          valid = false ;
          break ;
        } 
        if( d.from_date === undefined || d.from_date === "" ){
          this.$vToastify.error( "Campo Desde requerido", "¡Error!");
          valid = false ;
          break ;
        }
        if( d.to_date === undefined || d.to_date === "" ) {
          this.$vToastify.error( "Campo Hasta requerido", "¡Error!");
          valid = false ;
          break ;
        }
        
        if( d.vigencia === undefined || d.vigencia === "" ){
          this.$vToastify.error( "Campo Vigencia requerido", "¡Error!");
          valid = false ;
          break ;
        } 
        if( d.margin === undefined || d.margin === "" ){
          this.$vToastify.error( "Campo Margen requerido", "¡Error!");
          valid = false ;
          break ;
        } 
        if( d.container_id.id === undefined || d.container_id.id === "" ){
          this.$vToastify.error( "Campo Unidad requerido", "¡Error!");
          valid = false ;
          break ;
        } 
        if( d.products_category_id.id === undefined || d.products_category_id.id === "" ) {
          this.$vToastify.error( "Campo Commodity requerido", "¡Error!");
          valid = false ;
          break ;
        } 
        if( d.atmosphere_id.id === undefined || d.atmosphere_id.id === "" ){
          this.$vToastify.error( "Campo Atmósfera requerido", "¡Error!");
          valid = false ;
          break ;
        } 

        if( d.comment === undefined || d.comment === "" ){
          this.$vToastify.error( "Campo Comentario requerido", "¡Error!");
          valid = false ;
          break ;
        } 

      }

      if( !valid ) return ;

      const form = {
        tariff_clients: this.dataAux.map(
          ({ id, cliente_id, naviera, pod, pol, from_date, to_date, vigencia, margin, container_id, products_category_id, atmosphere_id, coldtreatment, genset, comment }) => {
          return {
            id,
            cliente_id:cliente_id.id, 
            naviera : naviera.id,
            pod: pod.id,
            pol: pol.id,
            from_date,
            to_date,
            vigencia,
            margin, 
            container_id: container_id.id,
            products_category_id: products_category_id.id,
            atmosphere_id: atmosphere_id.id,
            coldtreatment: typeof coldtreatment === "object" ? (coldtreatment.name || "") : (coldtreatment || ""),
            genset, 
            comment ,
            // tipo_contrato_id: tipo_contrato_id.name,
            // tariff_contract: tariff_contract.name
          };
        }) 
      }
      this.estadoButton("Actualizando...");
      this.$vToastify.loader("Realizando Solicitud...");

      try {
        
        await editarAcuerdoBaseClientes( form ) ;
        const { data_table } = await getAcuerdosClientesBase( );

        this.$vToastify.stopLoader();
        this.actionSetDataListarTarifasAcuerdosClientesBase( data_table );
        this.limpiarChecks() ;
        this.closeModal('modal');
        this.estadoButton("Actualizar", false);
        this.$vToastify.success(
          "Acuerdo de Cliente Bases seleccionados actualizados correctamente",
          "¡Realizado!"
        );
      } catch (error) {
        this.$vToastify.stopLoader();
        this.estadoButton("Actualizar", false);

        return this.$vToastify.error(
          "Error al editar acuerdos clientes base, intente más tarde.",
          "¡Error!"
        );
      }
    },

    async editarMultiple() {

      this.load = true;

      if (this.acuerdoClientesBaseArreglo.length === 0) return this.$vToastify.warning(
        "Debe seleccionar registros para editar.",
        "!Precaución¡"
      );

      this.openModal("modal");

      try {
        const { data_table } = await getAcuerdosClientesBaseByIds(this.acuerdoClientesBaseArreglo);

        let dataListas = await getListasAcuerdosBase();

        this.filtroContenedores = dataListas.filtro_contenedores;

        this.filtroCommodity = dataListas.lista_prod_categories;

        this.filtroAtmosferas = dataListas.lista_atmosferas;
        this.filtroColdtreatmentAux = dataListas.lista_coldtreatment || this.filtroColdtreatment || [];

        // Filtros
        this.dataAux = data_table.map(al => (
            {
              id: al.data_complementaria.id,
              cliente_id: {
                id: al.data_complementaria.cliente_id.id,
                name: al.data_complementaria.cliente_id.name
              },
              naviera: {
                id: al.data_complementaria.naviera_id.id,
                name: al.data_complementaria.naviera_id.name
              },
              naviera_salida: al.data[2],
              pod: {
                id: al.data_complementaria.pod.id,
                name: al.data_complementaria.pod.name
              },
              pol: {
                id: al.data_complementaria.pol.id,
                name: al.data_complementaria.pol.name
              },
              margin: al.data_complementaria.margin,
              neta_cliente: al.data_complementaria.neta_cliente,
              from_date: al.data_complementaria.from_date,
              to_date: al.data_complementaria.to_date,
              transit_time: al.data_complementaria.transit_time,
              neta: al.data_complementaria.neta,
              public_value: al.data_complementaria.public_value,
              vigencia: al.data_complementaria.vigencia,
              container_id: {
                id: +al.data_complementaria.container_id.id,
                code: al.data_complementaria.container_id.name
              },
              products_category_id: {
                id: +al.data_complementaria.products_category_id.id,
                name: al.data_complementaria.products_category_id.name
              },
              descuento: parseInt(al.data_complementaria.public_value) - parseInt(al.data_complementaria.neta),
              atmosphere_id: {
                id: +al.data_complementaria.atmosphere_id.id,
                name: al.data_complementaria.atmosphere_id.name
              },
              coldtreatment: al.data_complementaria.coldtreatment && al.data_complementaria.coldtreatment !== "-"
                ? {
                    id: al.data_complementaria.coldtreatment_id || "",
                    name: al.data_complementaria.coldtreatment,
                  }
                : { id: "", name: "" },
              free_days_embark: al.data_complementaria.free_days_embark,
              plug_days_embark: al.data_complementaria.plug_days_embark,
              free_days_land: al.data_complementaria.free_days_land,
              plug_days_land: al.data_complementaria.plug_days_land,
              genset: al.data_complementaria.genset === "Si",
              get_out: al.data_complementaria.get_out,
              comment: al.data_complementaria.comment,
              tipo_contrato_id: {
                id: al.data_complementaria.tipo_contrato.id,
                name: al.data_complementaria.tipo_contrato.name
              },
              tariff_contract: {
                id: al.data_complementaria.tariff_contract_id,
                name: al.data_complementaria.tariff_contract_name,
                contrato: `${ al.data_complementaria.tariff_contract_id.name } - ${ al.data_complementaria.tariff_contract_id.number }`
              }
            }
          )
        );

        this.load = false;

      } catch (error) {

        this.load = false;

        return this.$vToastify.error(
          "Error al obtener registros, recargue la página y vuelva a intentar",
          "¡Error!"
        );
      }
    },
    openModal(ref) {
      this.ActionSetZindexTablaModal(true);
      this.$refs[ref].open();
    },
    closeModal(ref) {
      this.ActionSetZindexTablaModal(false);
      this.$refs[ref].close();
    },
    cerrarModal() {
      //this.ActionSetZindexModal(false);
    },
  },
  computed: {
    ...mapState(["showAcuerdoLineasClienteBase"])
  },
  components: {
    Button,
    DataTableAcuerdosClientesBase
  },
  watch: {

  },
};
</script>

<style>
  .modal-editar-multiple-acuerdo-cliente-base .ui-modal__container {
    width: 100% !important;
  }
</style>
